import React from 'react';

function DataWeek(props) {
  const res = (props._data) ? props._data.filter((el) => el.id > 0) : 0;

  const clk = (id) => {
    props._clk(id);
  };

  const GridData = (props) => {
    const cl = ['free_w', 'n_period_w', 's_period_w', 'k_period_w', 'nk_period_w'];
    const cl_common = 'common_w';
    return props._data.days.map((it, index) => <div
      className={cl_common + ' ' + cl[it]} onClick={() => clk(props._data.clientID[index])} key={index}></div>);
  };

  return (
    <>
      {
        ((res) ?
          res.map((item, index) =>
            <div className="rec_calendar_w" key={index}>
              <div className="num_room_w common_w">
                {item.name_room}
              </div>
              <GridData _data={item}/>
            </div>
          )
          :
          <div></div>)
      }
    </>
  );
}

export default DataWeek;
